import { FC } from 'react';
import clsx from 'clsx';

import styles from './TwoSideLayout.module.css';
import { TwoSideLayoutProps } from './types';

const TwoSideLayout: FC<TwoSideLayoutProps> = ({ rightSide, leftSide, rightSideClass, className }) => (
  <div className={clsx(styles.twoSideLayout, className)}>
    <article className={styles.article}>{leftSide}</article>
    <aside className={clsx(styles.aside, rightSideClass)}>{rightSide}</aside>
  </div>
);

export default TwoSideLayout;
